// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P32h","select":"styles_select__3GJg4"};